export function trackUnfavoriteStation(station) {
  const { name, collectionTitle } = station;
  window.Taq.push([
    'track',
    'link',
    {
      ...window.Taq.jukeCustomData,
      event_name: 'content-interactions_remove-my-category',
      event_category: 'content-interactions',
      event_action: 'remove-my-category',
      event_label: name || null,
      player_channel: name || null,
      c_media_music_type: 'station',
      content_id: collectionTitle || null,
    },
  ]);
}

export function trackFavoriteStation(station) {
  const { name, collectionTitle } = station;
  window.Taq.push([
    'track',
    'link',
    {
      ...window.Taq.jukeCustomData,
      event_name: 'content-interactions_add-my-category',
      event_category: 'content-interactions',
      event_action: 'add-my-category',
      event_label: name || null,
      player_channel: name || null,
      c_media_music_type: 'station',
      content_id: collectionTitle || null,
    },
  ]);
}

export function trackFavoritePodcast(podcast) {
  const { title } = podcast;
  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'content-interactions_add-my-category',
      event_category: 'content-interactions',
      event_action: 'add-my-category',
      event_label: title || null,
      player_channel: title || null,
      c_media_music_type: 'podcast',
    },
  ]);
}

export function trackUnfavoritePodcast(podcast) {
  const { title } = podcast;

  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'content-interactions_remove-my-category',
      event_category: 'content-interactions',
      event_action: 'remove-my-category',
      event_label: title || null,
      player_channel: title || null,
      c_media_music_type: 'podcast',
    },
  ]);
}
export function trackFavoriteClip(clip) {
  const { title } = clip;
  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'content-interactions_add-my-category',
      event_category: 'content-interactions',
      event_action: 'add-my-category',
      event_label: title || null,
      player_channel: title || null,
      c_media_music_type: 'podcast-episode',
    },
  ]);
}

export function trackUnfavoriteClip(clip) {
  const { title } = clip;

  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'content-interactions_remove-my-category',
      event_category: 'content-interactions',
      event_action: 'remove-my-category',
      event_label: title || null,
      player_channel: title || null,
      c_media_music_type: 'podcast-episode',
    },
  ]);
}

export function trackFavoriteTrack(track, station) {
  const trackId = track ? `${track.isrc} - ${track.artist} - ${track.title}` : null;
  const { name } = station;
  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'juke-player_add-my-category',
      event_category: 'juke-player',
      event_action: 'add-my-category',
      event_label: trackId,
      player_channel: name || null,
      c_media_music_type: 'track',
      c_media_music_trackname: trackId,
    },
  ]);
}

export function trackUnfavoriteTrack(track, station) {
  const trackId = track ? `${track.isrc} - ${track.artist} - ${track.title}` : null;
  const { name } = station;
  window.Taq.push([
    'track',
    'link',
    {
      event_name: 'juke-player_remove-my-category',
      event_category: 'juke-player',
      event_action: 'remove-my-category',
      event_label: trackId,
      player_channel: name || null,
      c_media_music_type: 'track',
      c_media_music_trackname: trackId,
    },
  ]);
}
